import XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import moment from 'moment'
import store from '@/store'
import { Message, Loading } from 'element-ui'

export function numFormat(num, point = 2) {
  return Number(Number(num).toFixed(point)).toLocaleString() // 不写语言和echart内置的保持统一
}

export const emptyFormat = v => (v === '' || v === null ? '－' : v)

export function checkReq(res, code = 200) {
  if (res.data.code === code) {
    return true
  } else {
    Message({
      message: res.data.message || res.data.msg || 'Error',
      type: 'error',
      duration: 2000
    })
    return false
  }
}

export function typeDataFormat(arr, type = 'type') {
  let obj = {}
  arr.forEach(v => {
    if (!obj[v[type]]) obj[v[type]] = []
    obj[v[type]].push(v)
  })
  return obj
}

// 创建并下载xlsx
export function createAndDownloadXLSX({ list = [], name, colsConfig, merges }) {
  // 创建一个工作簿
  const workbook = XLSX.utils.book_new()
  // 创建一个工作表
  const worksheet = XLSX.utils.json_to_sheet(list)
  if (colsConfig) {
    worksheet['!cols'] = []
    for (let i in colsConfig) {
      worksheet['!cols'][i] = { wch: colsConfig[i] }
    }
  }
  if (merges) worksheet['!merges'] = merges
  // 将工作表添加到工作簿
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
  // 将工作簿转换为二进制数据
  const excelData = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
  // 将二进制数据转换为Blob对象
  const blob = new Blob([excelData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
  // 生成文件名
  const fileName = name + '.xlsx'
  // 下载文件
  saveAs(blob, fileName)
}

// 数组转对象
export function arrToObj(arr, key, valueKey) {
  let obj = {}
  arr.forEach(v => {
    obj[v[key]] = valueKey ? v[valueKey] : v
  })
  return obj
}

// 获取用户本地时间(支持UTC的TZ格式,不传取当前时间)
let iso8601Regex = /^(?=.*T)(?=.*Z).*$/
export function getLocalTime(time, format = 'YYYY-MM-DD HH:mm:ss') {
  let momentTime
  if (time && typeof time === 'string' && iso8601Regex.test(time)) {
    momentTime = moment.utc
  } else {
    momentTime = moment
  }
  return (time ? momentTime(time) : momentTime()).utcOffset(store.getters.usertime.time).format(format)
}

// UTC时间转用户本地时间（仅用于UTC格式或者时间戳，兼容safri浏览器写法。如：2023-08-15T13:45:06Z、utc的2023-08-15 13:45:06）
export function getUTCToLocalTime(time, format = 'YYYY-MM-DD HH:mm:ss') {
  return moment
    .utc(time)
    .utcOffset(store.getters.usertime.time)
    .format(format)
}

// UTC时间转自定义tz时间
export function getUTCToCustomTime(time, timeZone, format = 'YYYY-MM-DD HH:mm:ss') {
  return moment
    .utc(time)
    .utcOffset(timeZone)
    .format(format)
}

// 本地用户时间转UTC时间
export function setLocalTimeToUTC(time, format = 'YYYY-MM-DD HH:mm:ss') {
  const usertime = store.getters.usertime.time
  let timeSymbol = 1
  if (usertime.slice(0, 1) === '-') {
    timeSymbol = -1
  }
  const halfZone = +usertime.slice(4, 6) / 60
  const realTime = timeSymbol * (+usertime.slice(1, 3) + halfZone)
  return moment(time, format)
    .subtract(realTime, 'hour')
    .format(format)
}

// 本地用户时间转UTC时间
export function setLocalTimeToUTCWithTimezone(time, format = 'YYYY-MM-DD HH:mm:ss', timezone) {
  const usertime = timezone
  let timeSymbol = 1
  if (usertime.slice(0, 1) === '-') {
    timeSymbol = -1
  }
  const halfZone = +usertime.slice(4, 6) / 60
  const realTime = timeSymbol * (+usertime.slice(1, 3) + halfZone)
  return moment(time, format)
    .subtract(realTime, 'hour')
    .format(format)
}

// 是否是测试环境
export const isDev = window.location.host.includes('internal') || process.env.NODE_ENV === 'development'

export const env = isDev ? 'test' : window.location.host.includes('uat') ? 'uat' : 'prod'

// 打开新窗口
let windowReference = null
let windowReferenceUrl = ''
export function openWindow(url, { width = 500, height = 700 } = {}) {
  // 上一个弹框存在没有关闭且Url地址一样
  if (windowReference && !windowReference.closed && windowReferenceUrl === url) {
    windowReference.focus()
  } else {
    let l = (screen.availWidth - width) / 2
    let t = (screen.availHeight - height) / 2
    windowReference = window.open(url, '', `top=${t},left=${l}, width=${width},height=${height},toolbar=no, menubar=no`)
    windowReferenceUrl = url
  }
}

export function handleCopy(str) {
  const copyInput = document.createElement('input')
  copyInput.setAttribute('value', str)
  document.body.appendChild(copyInput)
  copyInput.select()
  document.execCommand('copy')
  document.body.removeChild(copyInput)
}

// 防抖
export function debounce(fn, delay = 300) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(function () {
      fn(...args)
    }, delay)
  }
}

export function aTagJump(url) {
  var el = document.createElement('a')
  document.body.appendChild(el)
  el.href = url
  el.target = '_blank'
  el.click()
  document.body.removeChild(el)
}

export function openLoading(text = 'Loading..') {
  return Loading.service({
    lock: true,
    text,
    spinner: '',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}

// 获取文件后缀名
export function getFileSuffix(filename) {
  const dotIndex = filename.lastIndexOf('.')
  if (dotIndex === -1 || dotIndex === filename.length - 1) {
    return ''
  } else {
    return filename.substring(dotIndex + 1).toLowerCase()
  }
}

// 字符串转数组
export function strToArr(arr) {
  return arr ? arr.split(',') : []
}

// 数组1包含数组2
export function includes(arr1, arr2) {
  return arr2.every(val => arr1.includes(val))
}

// 语言map
export const langMap = {
  zh: 'zh-CN',
  en: 'en-US',
  ba: 'id-ID'
}

// 获取客户当前时间
export function getLocalDate() {
  return new Date(
    moment()
      .utcOffset(store.getters.usertime.time)
      .format('YYYY-MM-DD HH:mm:ss')
  )
}

// ipv4/ipv6 + mask
export const ipReg = /^((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/(\d|[1-2]\d|3[0-2]))?$|^([\da-fA-F]{1,4}:){6}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^::([\da-fA-F]{1,4}:){0,4}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:):([\da-fA-F]{1,4}:){0,3}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){2}:([\da-fA-F]{1,4}:){0,2}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){3}:([\da-fA-F]{1,4}:){0,1}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){4}:((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){7}[\da-fA-F]{1,4}(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^:((:[\da-fA-F]{1,4}){1,6}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^[\da-fA-F]{1,4}:((:[\da-fA-F]{1,4}){1,5}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){2}((:[\da-fA-F]{1,4}){1,4}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){3}((:[\da-fA-F]{1,4}){1,3}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){4}((:[\da-fA-F]{1,4}){1,2}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){5}:([\da-fA-F]{1,4})?(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){6}:(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$/



// WEBPACK FOOTER //
// ./src/utils/util.js